





















import Vue, { PropType } from 'vue';
import { Column, Row } from '@/components/table/types';
import toLocaleString from '@/utils/toLocaleString';

export default Vue.extend({
  name: 'TotalRow',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object as PropType<Row>,
    },
    columnsData: {
      type: Array as PropType<Array<Column>>,
    },
  },
  methods: {
    formatValue(value: number) {
      return toLocaleString(value);
    },
  },
  data: function () {
    return {};
  },
});
